import apiClient from './api';
import {
  Announcement,
  CreateAnnouncementRequest,
  UpdateAnnouncementRequest,
  SearchAnnouncementsRequest,
  SearchAnnouncementsResponse,
} from '../types';

export const announcementService = {
  // 모든 공지사항 조회
  async getAllAnnouncements(): Promise<Announcement[]> {
    const response = await apiClient.get<Announcement[]>('/announcements');
    return response.data;
  },

  // 최근 공지사항 조회
  async getRecentAnnouncements(limit: number = 3): Promise<Announcement[]> {
    const response = await apiClient.get<Announcement[]>(`/announcements?limit=${limit}&sortBy=createdAt&sortOrder=desc`);
    return response.data;
  },

  // 특정 공지사항 조회
  async getAnnouncement(announcementId: string): Promise<Announcement> {
    const response = await apiClient.get<Announcement>(`/announcements/${announcementId}`);
    return response.data;
  },

  // 공지사항 생성
  async createAnnouncement(announcementData: CreateAnnouncementRequest): Promise<Announcement> {
    const response = await apiClient.post<Announcement>('/announcements', announcementData);
    return response.data;
  },

  // 공지사항 수정
  async updateAnnouncement(announcementId: string, announcementData: UpdateAnnouncementRequest): Promise<Announcement> {
    const response = await apiClient.patch<Announcement>(`/announcements/${announcementId}`, announcementData);
    return response.data;
  },

  // 공지사항 삭제
  async deleteAnnouncement(announcementId: string): Promise<void> {
    await apiClient.delete(`/announcements/${announcementId}`);
  },

  // 기간별 공지사항 조회
  async getAnnouncementsByDateRange(startDate: string, endDate: string): Promise<Announcement[]> {
    const response = await apiClient.get<Announcement[]>(
      `/announcements/date-range?startDate=${startDate}&endDate=${endDate}`
    );
    return response.data;
  },

  // 고급 검색
  async searchAnnouncements(searchParams: SearchAnnouncementsRequest): Promise<SearchAnnouncementsResponse> {
    const params = new URLSearchParams();
    
    if (searchParams.query) params.append('query', searchParams.query);
    if (searchParams.searchType) params.append('searchType', searchParams.searchType);
    if (searchParams.searchField) params.append('searchField', searchParams.searchField);
    if (searchParams.startDate) params.append('startDate', searchParams.startDate);
    if (searchParams.endDate) params.append('endDate', searchParams.endDate);
    if (searchParams.limit) params.append('limit', searchParams.limit.toString());
    if (searchParams.offset) params.append('offset', searchParams.offset.toString());
    if (searchParams.sortBy) params.append('sortBy', searchParams.sortBy);
    if (searchParams.sortOrder) params.append('sortOrder', searchParams.sortOrder);

    const response = await apiClient.get<SearchAnnouncementsResponse>(`/announcements/search?${params.toString()}`);
    return response.data;
  },

  // 간단한 검색
  async searchAnnouncementsSimple(query: string): Promise<Announcement[]> {
    const response = await apiClient.get<Announcement[]>(`/announcements/search/simple?q=${encodeURIComponent(query)}`);
    return response.data;
  },

  // 공지사항 승인
  async approveAnnouncement(announcementId: string): Promise<Announcement> {
    const response = await apiClient.post<Announcement>(`/announcements/${announcementId}/approve`);
    return response.data;
  },

  // 공지사항 승인 취소
  async unapproveAnnouncement(announcementId: string): Promise<Announcement> {
    const response = await apiClient.post<Announcement>(`/announcements/${announcementId}/unapprove`);
    return response.data;
  },
}; 